"use strict";
/** state: Final **/
/** family: SingleSelect **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var SingleSelectOption_1 = require("../SingleSelectOption");
var CLASS_NAME = 'i-single-select';
var SingleSelect = (function (_a) {
    var children = _a.children, className = _a.className, fullWidth = _a.fullWidth, placeholder = _a.placeholder, value = _a.value, restProps = __rest(_a, ["children", "className", "fullWidth", "placeholder", "value"]);
    var _b, _c;
    return (React.createElement("div", null,
        React.createElement("div", { className: classNames(CLASS_NAME + "__wrapper", (_b = {},
                _b[CLASS_NAME + "__wrapper--disabled"] = restProps.disabled,
                _b[CLASS_NAME + "__wrapper--full-width"] = fullWidth,
                _b)) },
            React.createElement("select", __assign({ className: classNames(CLASS_NAME, className, 'form-control', (_c = {},
                    _c[CLASS_NAME + "--full-width"] = fullWidth,
                    _c)), defaultValue: !restProps.onChange ? value : undefined, value: restProps.onChange ? value : undefined }, restProps),
                placeholder && (React.createElement(SingleSelectOption_1.SingleSelectOption, { value: "", disabled: true, hidden: true, selected: !value }, placeholder)),
                children))));
});
exports.SingleSelect = SingleSelect;
SingleSelect.Option = SingleSelectOption_1.SingleSelectOption;
//# sourceMappingURL=SingleSelect.js.map